import {
    Box,
    Typography,
    FormControlLabel,
    Switch,
    Button,
    Grid,
    Paper
} from '@mui/material';

function PollerConfigSection({ config, onChange, onSave, hasChanges, localisation }) {
    return (
        <Box sx={{ textAlign: 'left' }}>
            <Typography variant="h6" gutterBottom sx={{ mb: 3, fontWeight: 500 }}>
                Poller Settings
            </Typography>

            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 1 }}>
                        Filename Metadata Extraction
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <Paper variant="outlined" sx={{ p: 2 }}>
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={config.enabled || false}
                                    onChange={(e) => onChange('enabled', e.target.checked)}
                                />
                            }
                            label="Enable Split Filename"
                        />
                        <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                            When enabled, the poller will attempt to extract a transaction date and username
                            from the filename of imported documents. The expected filename format is:
                        </Typography>
                        <Typography
                            variant="body2"
                            color="text.secondary"
                            sx={{ mt: 0.5, fontFamily: 'monospace', fontSize: '0.8rem' }}
                        >
                            {'<reference>.<unixTimestamp>.<username>.<extension>'}
                        </Typography>
                    </Paper>
                </Grid>
            </Grid>

            <Button
                variant="contained"
                color="primary"
                onClick={onSave}
                disabled={!hasChanges}
                sx={{ mt: 3 }}
            >
                {localisation?.["save_button"]?.element_lang || "Save"}
            </Button>
        </Box>
    );
}

export default PollerConfigSection;
